import { render, staticRenderFns } from "./EndOfLife.vue?vue&type=template&id=3b67b32f&"
import script from "./EndOfLife.vue?vue&type=script&lang=js&"
export * from "./EndOfLife.vue?vue&type=script&lang=js&"
import style0 from "./EndOfLife.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports